import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_STOCK_TRANSFER_REPORT_REQUEST,
  FETCH_STOCK_TRANSFER_REPORT_SUCCESS,
  FETCH_STOCK_TRANSFER_REPORT_ERROR,
  FETCH_STOCK_TRANSFER_MISSION_BLOCK_REQUEST,
  FETCH_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS,
  FETCH_STOCK_TRANSFER_MISSION_BLOCK_ERROR,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK_REQUEST,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK_ERROR,
} from 'actionTypes'
import { UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_ERROR, UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_REQUEST, UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS } from '../constants/actionTypes'

export const fetch = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    dispatch(actionSet(FETCH_STOCK_TRANSFER_REPORT_REQUEST))

    const response = await new Api(token, dispatch).post(
      API_URL.STOCK_TRANSFER_REPORT,
      param
    )

    dispatch(getPages(response.metadata))

    return dispatch(
      actionSet(FETCH_STOCK_TRANSFER_REPORT_SUCCESS, response.data)
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_STOCK_TRANSFER_REPORT_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

export const fetchMissionDepositBlock = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    dispatch(actionSet(FETCH_STOCK_TRANSFER_MISSION_BLOCK_REQUEST))

    const response = await new Api(token, dispatch).post(
      API_URL.FETCH_STOCK_TRANSFER_MISSION_BLOCK,
      param
    )

    dispatch(getPages(response.metadata))

    return dispatch(
      actionSet(FETCH_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS, response.data)
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_STOCK_TRANSFER_MISSION_BLOCK_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}


export const updateAllMissionDepositBlock = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    dispatch(actionSet(UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_REQUEST))
    await new Api(token, dispatch).post(API_URL.UPDATE_STOCK_TRANSFER_MISSIONS_BLOCK, param)
    return dispatch(actionSet(UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS))
  }
  catch(error) {
    return dispatch(actionSet(UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_ERROR))
  }

  finally {
    dispatch(hideSpinner())
  }
}
export const saveMissionDepositBlock = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    dispatch(actionSet(SAVE_STOCK_TRANSFER_MISSION_BLOCK_REQUEST))

    await new Api(token, dispatch).post(
      API_URL.SAVE_STOCK_TRANSFER_MISSION_BLOCK,
      param
    )

    return dispatch(actionSet(SAVE_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS))
  } catch (error) {
    return dispatch(actionSet(SAVE_STOCK_TRANSFER_MISSION_BLOCK_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}
